import { canReadSalesOrders } from './searchScopes.mjs';

export default {
    data: () => ({ salesHits: [], salesLoading: false, salesError: '', salesHasMore: false, salesTerm: '', salesSequence: 0, salesTimer: null }),
    computed: { canSearchSales() { return canReadSalesOrders(this.$store.state.user.userdata); } },
    beforeDestroy() { clearTimeout(this.salesTimer); this.salesSequence++; },
    methods: {
        scheduleSalesSearch(value, explicit = false) {
            clearTimeout(this.salesTimer);
            const sequence = ++this.salesSequence;
            this.salesHits = []; this.salesError = ''; this.salesHasMore = false;
            const text = String(value || '').trim();
            this.salesTerm = this.canSearchSales && text.length >= 3 && (explicit || /^ODV\d/i.test(text)) ? text : '';
            this.salesLoading = Boolean(this.salesTerm);
            if (this.salesTerm) this.salesTimer = setTimeout(() => this.loadSalesSearch(this.salesTerm, sequence), 250);
        },
        async loadSalesSearch(term, sequence) {
            try {
                const response = await this.$work.get('/search/sales-orders/', { q: term }, false, null, { ignoreGlobalErrorStatuses: [400, 403, 503] });
                if (!Array.isArray(response?.data?.items)) throw new Error('Risposta non valida');
                if (sequence !== this.salesSequence) return;
                this.salesHits = response.data.items.map(item => ({ codice: item.numero, descrizione: [item.ragione_sociale, item.riferimento, item.data].filter(Boolean).join(' · '), route: 'OrdineVendita', searchType: 'sales-order' }));
                this.salesHasMore = response.data.has_more;
            } catch (error) {
                if (sequence === this.salesSequence) this.salesError = error.response?.status === 403 ? 'Non hai accesso agli ordini clienti.' : 'Ricerca ordini clienti non disponibile. Riprova.';
            } finally { if (sequence === this.salesSequence) this.salesLoading = false; }
        },
    },
};
